import { Rect } from '@geom';

// Always escape HTML for text arguments!
export function escapeHtml(html: string): string {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}

export function getElementBounds(
  element: HTMLElement,
  zeroTopLeft = true
): Rect | undefined {
  let r = Rect.fromDOMRect(element.getBoundingClientRect());

  if (r === undefined) {
    return undefined;
  }

  if (zeroTopLeft) {
    r = r.aligningTopLeftToOrigin();
  }

  return r;
}
